import { stylesheet } from 'astroturf';
import styled from 'astroturf/react';
import Svg from 'src/components/Svg';
import Button from 'src/components/Button';

const MorePopup = styled('div')`
  &.company {
    padding: 10px;
    overflow: visible;
  }

  &.list {
    label {
      background-color: var(--transparent);
      border-radius: 0;
      padding: 0 0 0 25px;
      color: var(--black);
      font-size: var(--ph-text-sm);
    }

    label[class*='textField'] {
      padding: 0;
      margin: 0;
    }
  }

  &.date {
    padding: 10px;
    overflow: visible;

    label {
      border: 0;
      min-height: 36px;
      background-color: transparent;
      margin-left: 0;
      padding: 0;
    }

    div[class*='datePickerFieldLabel'] {
      flex: 0 0 50px;
      min-width: 50px;
      border: 0;
      padding: 10px 10px 10px 0;
    }

    label + label {
      margin-top: 10px;
    }

    input {
      min-height: 36px;
      background-color: var(--white);
      border-radius: var(--ph-border-radius-sm);
    }

    div[class*='date-icon-div'] {
      path,
      rect {
        stroke: var(--ph-gray-500);
      }
    }
  }
`;

const MoreSearch = styled('div')`
  position: relative;

  label {
    margin: 0;
    padding: 0;
    border: 0;
    border-bottom: solid 1px var(--white);
  }

  input {
    background-color: transparent;
    color: var(--white);
  }
`;

const PopupTextField = styled('div')`
  position: relative;
  margin: 8px;

  label {
    margin: 0;
    padding: 0;
    border: 0;
    min-height: 36px;
    background-color: transparent;
  }

  input {
    background-color: var(--white);
    color: var(--black);

    &::placeholder {
      font-size: var(--ph-text-sm);
      font-weight: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: var(--ph-gray-500);
    }
  }
`;

const MoreSearchIcon = styled(Svg)`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translate(0%, -50%);
  width: 20px;

  path {
    fill: var(--ph-gray-500);
  }

  &.funnel {
    width: 12px;
  }

  &.check {
    width: 12px;
    right: 50%;
    transform: translate(50%, -50%);

    polyline {
      stroke: var(--white);
    }
  }
`;

const TextConfirmButton = styled(Button)`
  position: absolute;
  right: 5px;
  top: 3px;
  width: 24px;
  height: 24px;
  min-width: 0;
  padding: 0;

  &:hover {
    background-color: var(--ph-orange-700);
  }

  &:active {
    background-color: var(--ph-orange-900);
  }

  &:focus {
    box-shadow: var(--ph-box-shadow-focus);
  }
`;

const MoreContent = styled('div')`
  max-height: 200px;
  overflow-y: auto;
`;

const MoreContentItem = styled('div')`
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: var(--white);
  margin: 10px 20px;
  cursor: pointer;
`;

const FilterWrapper = styled('div')`
  position: relative;
  margin-left: 10px;
`;

const FilterLabel = styled('div')`
  border-radius: var(--ph-border-radius-sm);
  background-color: var(--ph-gray-50);
  padding: 1px 8px;
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.86;
  letter-spacing: normal;
  color: var(--ph-gray-500);
  margin-right: 13px;
  cursor: pointer;

  &.changed {
    background-color: #68615c;
    color: var(--white);
  }
`;

const FilterRemoveBtn = styled(Svg)`
  position: absolute;
  right: 0;
  top: 0;
  width: 7px;
  cursor: pointer;

  path {
    fill: #67605b;
  }
`;

const ButtonsRow = styled('div')`
  margin: 20px 0 0;

  button + button {
    margin-left: 10px !important;
  }

`;

const Stylesheets = stylesheet`
  .company-select {
    position: relative;
    margin: 8px;
    color: var(--white) !important;
  }

  .company-select-container {
    color: var(--white) !important;
  }

  .company-select__value-container {
    font-size: 1.6rem !important;
    line-height: 1.25 !important;
    padding: 0.8rem 1.6rem !important;
    color: white !important;
    height: 36px !important;
  }

  .company-select__control {
    min-height: 36px !important;
    background-color: var(--white) !important;
    border: 0 !important;
    border-radius: 0 !important;
    color: var(--white) !important;
  }

  .company-select__single-value {
    color: var(--white) !important;
    font-size: 1.6rem !important;
    line-height: 1.25 !important;
  }

  .company-select__input {
    color: var(--white) !important;
    font-size: 1.6rem !important;
    line-height: 1.25 !important;
  }

  .company-select__menu {
    background-color: var(--white) !important;
  }

  .company-select__menu-list {
    background-color: var(--black) !important;
    border-radius: var(--ph-border-radius-sm);
  }

  .company-select__option {
    background-color: var(--black) !important;
  }
`;

export default {
  Stylesheets,
  MorePopup,
  MoreSearch,
  PopupTextField,
  MoreSearchIcon,
  MoreContent,
  MoreContentItem,
  FilterWrapper,
  FilterLabel,
  FilterRemoveBtn,
  TextConfirmButton,
  ButtonsRow,
};
